
/**
 * pdf（切换）方向
 * @param state
 * @param payload
 */
export const siderCollapsed = (state, payload) => {
  state.siderCollapsed = payload;
}
/**
 * 当前在几个处于正在加载中
 * @param state
 * @param payload
 */
export const loadingCounter = (state, payload) => {
  state.loadingCounter += payload;
}
/**
 * 保存登录信息
 * @param state
 * @param payload
 */
export const setUserInfo = (state, payload) => {
  state.userInfo = payload;
}

export const setRouters = (state, payload)=> {
  state.routers = payload;
}
/**
 * 缓存区域机构
 * @param state
 * @param payload
 */
export const setAreaOrgs = (state, payload)=> {
  state.areaOrgs = payload;
}
/**
 * 通过哪个登陆界面进入系统：1-通用；2-昆明；3-南海妇幼
 * @param state
 * @param payload
 */
export const setLoginBy = (state, payload)=> {
  state.loginBy = payload;
}

export const setUserSetting = (state, payload) => {
  state.userSetting = payload;
}



// WEBPACK FOOTER //
// ./src/store/mutations.js